module.exports = __webpack_public_path__ + "static/Excellent_support-425b644c4ce46aea29abdc673c197bc1.png";